import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {
	PatchFavoritePlace,
  PatchFavoritePlaceRequest,
  PatchFavoritePlaceResponse,
} from 'domain/usecases';

export class RemotePatchFavoritePlace implements PatchFavoritePlace {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PatchFavoritePlaceResponse>,
	) {}

	async patch(params: PatchFavoritePlaceRequest): Promise<PatchFavoritePlaceResponse> {
		const {signal, ...otherParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body: otherParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
